import { Grid, Stack, Text, Title, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import Link from 'next/link';
import classes from './FooterNavbar.module.css';
import { links } from './footerData';
export const FooterNavbar: React.FC = () => {
  const isMobile = useMediaQuery('(max-width: 36em)');
  return <Grid mt={82} gutter={24}>
      {links.map(link => <Grid.Col span={{
      base: 6,
      sm: 3,
      lg: 3
    }} key={link.title}>
          <Stack px={24} gap={8} className={link.title === 'Casino' || isMobile ? classes.borderNone : classes.borderLeft}>
            <Title fz={rem(13)} tt="uppercase" c="var(--text-dark)">
              {link.title}
            </Title>

            {link.footerLink.map(item => <Text fz={rem(12)} key={item.text} component={Link} href={item.url} c="var(--text-dark)" className={classes.item}>
                {item.text}
              </Text>)}
          </Stack>
        </Grid.Col>)}
    </Grid>;
};